
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"red"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.052 16.035l1.051 1.05-1.052 1.285c2.571 2.685 2.571 7.004 0 9.806-2.687 2.801-7.242 2.918-10.162.233-2.804-2.685-2.921-7.237-.234-10.156l-1.05-1.05 1.05-1.051 1.052 1.05a6.652 6.652 0 013.386-1.284v-1.517h-1.4V13h4.321v1.4h-1.402v1.402c1.169.116 2.337.583 3.389 1.284l1.05-1.05zm-10.514 6.888a5.233 5.233 0 005.257 5.253c2.92 0 5.256-2.218 5.256-5.253a5.233 5.233 0 00-5.256-5.254 5.233 5.233 0 00-5.257 5.254zm5.257.116v-3.385a3.389 3.389 0 013.388 3.385 3.388 3.388 0 01-6.775 0h3.387z","fill":"#fff"}}),_c('path',{attrs:{"d":"M25.502 14.4c.1 0 .2 0 .3-.1l3.102-3.1c.1-.1.1-.2.1-.3 0-.1-.1-.2-.1-.3l-.3-.3c-.1-.1-.2-.1-.3-.1-.1 0-.2.1-.3.1l-1.801 1.8V7.7c0-.4-.3-.7-.7-.7-.401 0-.701.3-.701.7v4.4L23 10.3c-.1-.1-.2-.1-.3-.1-.1 0-.2.1-.3.1l-.3.3c-.1.1-.1.2-.1.3 0 .1.1.2.1.3l3.1 3.1c.1 0 .2.1.3.1h.002z","fill":"#fff"}})])
          )
        }
      }
    